import React from "react"
import { Form, Image } from "react-bootstrap"

const HeroSectionForm = ({
  fields,
  onInputChange,
  upload,
  showAlert,
  isUploading,
  validationErrors,
  setValidationErrors,
  section = "heroSection"
}) => {
  const handleFileUpload = async (key, file) => {
    try {
      const res = await upload(file)
      if (res?.url) onInputChange(section, key, res.url)
    } catch (err) {
      showAlert("File upload failed.", "danger")
    }
  }

  const handleInputChange = (key, value) => {
    onInputChange(section, key, value)
    if (validationErrors[`${section}.${key}`]) {
      setValidationErrors((prev) => ({
        ...prev,
        [`${section}.${key}`]: undefined,
      }))
    }
  }

  return (
    <>
      <Form.Group className="mb-3">
        <Form.Label>
          Title {fields.isVisible && <span className="text-danger">*</span>}
        </Form.Label>
        <Form.Control
          type="text"
          placeholder={`Title ${fields.isVisible ? "*" : ""}`}
          value={fields.title || ""}
          onChange={(e) => handleInputChange("title", e.target.value)}
          isInvalid={!!validationErrors[`${section}.title`]}
        />
        {validationErrors[`${section}.title`] && (
          <Form.Control.Feedback type="invalid">
            {validationErrors[`${section}.title`]}
          </Form.Control.Feedback>
        )}
      </Form.Group>

      <div className="mb-3">
        <Form.Label>Background Image</Form.Label>
        <Form.Control
          type="file"
          accept="image/*"
          onChange={(e) =>
            e.target.files?.[0] &&
            handleFileUpload("backgroundImage", e.target.files[0])
          }
        />
        {isUploading && (
          <div className="text-muted small mt-1">Uploading...</div>
        )}
        {fields.backgroundImage && (
          <div className="mt-2">
            <Image
              src={fields.backgroundImage}
              alt="Background Preview"
              thumbnail
              style={{ maxWidth: "200px" }}
            />
          </div>
        )}
      </div>
    </>
  )
}

export default HeroSectionForm
